/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetOutfitsResultsQueryVariables = Types.Exact<{
  q: Types.Scalars["String"]["input"];
  outfitCacheId?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  filters?: Types.InputMaybe<Array<Types.FreestyleSearchFilterInput> | Types.FreestyleSearchFilterInput>;
}>;
export type GetOutfitsResultsQuery = {
  __typename?: "Query";
  shopContent?: {
    __typename?: "ShopContent";
    id: string;
    search?: {
      __typename?: "FreestyleSearch";
      id: string;
      outfits: {
        __typename?: "OutfitConnection";
        edges: Array<{
          __typename?: "OutfitEdge";
          node: {
            __typename?: "Outfit";
            id: string;
            items: Array<{
              __typename?: "OutfitItem";
              sticker?: {
                __typename?: "ModeStickerLabel";
                label: string;
                theme: Types.ModeStickerLabelTheme;
              } | null;
              laydown: {
                __typename?: "OutfitItemLaydown";
                maxHeight: number;
                maxWidth: number;
                x: number;
                y: number;
                xAnchor: string;
                yAnchor: string;
              };
              shopProductVariant?: {
                __typename?: "ShopProductVariant";
                sku: string;
                url: string;
                image?: {
                  __typename?: "ShopMedia";
                  id: string;
                  altText: string;
                  imageUrl: string;
                } | null;
              } | null;
            }>;
          };
        }>;
      };
    } | null;
  } | null;
};
export const GetOutfitsResultsDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getOutfitsResults"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "q"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "outfitCacheId"
        }
      },
      type: {
        kind: "NamedType",
        name: {
          kind: "Name",
          value: "String"
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "filters"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "FreestyleSearchFilterInput"
            }
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopContent"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "search"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "input"
              },
              value: {
                kind: "ObjectValue",
                fields: [{
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "query"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "q"
                    }
                  }
                }, {
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "outfitCacheId"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "outfitCacheId"
                    }
                  }
                }, {
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "filters"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "filters"
                    }
                  }
                }]
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "outfits"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "first"
                  },
                  value: {
                    kind: "IntValue",
                    value: "12"
                  }
                }],
                selectionSet: {
                  kind: "SelectionSet",
                  selections: [{
                    kind: "Field",
                    name: {
                      kind: "Name",
                      value: "edges"
                    },
                    selectionSet: {
                      kind: "SelectionSet",
                      selections: [{
                        kind: "Field",
                        name: {
                          kind: "Name",
                          value: "node"
                        },
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [{
                            kind: "FragmentSpread",
                            name: {
                              kind: "Name",
                              value: "Outfit"
                            }
                          }]
                        }
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "OutfitItem"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "OutfitItem"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "sticker"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "theme"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "laydown"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxHeight"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "maxWidth"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "x"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "y"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "xAnchor"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "yAnchor"
            }
          }]
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopProductVariant"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "image"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "id"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "altText"
                }
              }, {
                kind: "Field",
                alias: {
                  kind: "Name",
                  value: "imageUrl"
                },
                name: {
                  kind: "Name",
                  value: "transformedSrc"
                },
                arguments: [{
                  kind: "Argument",
                  name: {
                    kind: "Name",
                    value: "options"
                  },
                  value: {
                    kind: "ObjectValue",
                    fields: [{
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "sizePreset"
                      },
                      value: {
                        kind: "EnumValue",
                        value: "MEDIUM"
                      }
                    }, {
                      kind: "ObjectField",
                      name: {
                        kind: "Name",
                        value: "transformations"
                      },
                      value: {
                        kind: "ListValue",
                        values: [{
                          kind: "EnumValue",
                          value: "TRIM_EFFECT"
                        }, {
                          kind: "EnumValue",
                          value: "AUTO_FORMAT_QUALITY"
                        }, {
                          kind: "EnumValue",
                          value: "REPLACE_COLOR_FOR_SHOP"
                        }]
                      }
                    }]
                  }
                }]
              }]
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "sku"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "url"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Outfit"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "Outfit"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "items"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "OutfitItem"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetOutfitsResultsQuery__
 *
 * To run a query within a React component, call `useGetOutfitsResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutfitsResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutfitsResultsQuery({
 *   variables: {
 *      q: // value for 'q'
 *      outfitCacheId: // value for 'outfitCacheId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetOutfitsResultsQuery(baseOptions: Apollo.QueryHookOptions<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables> & ({
  variables: GetOutfitsResultsQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables>(GetOutfitsResultsDocument, options);
}
export function useGetOutfitsResultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables>(GetOutfitsResultsDocument, options);
}
// @ts-ignore
export function useGetOutfitsResultsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables>;
export function useGetOutfitsResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutfitsResultsQuery | undefined, GetOutfitsResultsQueryVariables>;
export function useGetOutfitsResultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables>(GetOutfitsResultsDocument, options);
}
export type GetOutfitsResultsQueryHookResult = ReturnType<typeof useGetOutfitsResultsQuery>;
export type GetOutfitsResultsLazyQueryHookResult = ReturnType<typeof useGetOutfitsResultsLazyQuery>;
export type GetOutfitsResultsSuspenseQueryHookResult = ReturnType<typeof useGetOutfitsResultsSuspenseQuery>;
export type GetOutfitsResultsQueryResult = Apollo.QueryResult<GetOutfitsResultsQuery, GetOutfitsResultsQueryVariables>;